import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Reveal } from './ui/Reveal';
const timeline = [{
  year: '2020',
  title: 'COVID-19 Federal Response',
  desc: 'Led continuity of operations achieving 80% telework transition while maintaining mission-critical supply chains for the Department of Defense.'
}, {
  year: '2017',
  title: 'Hurricane Response Operations',
  desc: 'Directed emergency logistics for multiple simultaneous hurricane relief efforts, coordinating federal and state agency support.'
}, {
  year: '2014',
  title: 'Ebola Crisis Response',
  desc: 'Sourced and delivered 110 treatment units across West Africa in just 10 days, enabling rapid medical intervention.'
}, {
  year: '2014',
  title: 'Syrian Refugee Relief',
  desc: 'Coordinated $125M in humanitarian supplies sourced from 30 countries to support displaced populations.'
}, {
  year: '2014',
  title: 'Afghanistan Drawdown',
  desc: 'Managed complex retrograde logistics for equipment and personnel withdrawal, ensuring accountability and security.'
}];
export function CrisisSection() {
  return <Section id="crisis" variant="charcoal" data-id="element-130">
      <SectionHeader title="Crisis Leadership" subtitle="Global Operations" data-id="element-131" />

      <div className="relative max-w-4xl mx-auto" data-id="element-132">
        {/* Vertical Line */}
        <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-white/10 transform md:-translate-x-1/2" data-id="element-133"></div>

        <div className="space-y-12" data-id="element-134">
          {timeline.map((item, index) => <Reveal key={index} delay={index * 150} data-id="element-135">
              <div className={`relative flex flex-col md:flex-row ${index % 2 === 0 ? 'md:flex-row-reverse' : ''} items-center`} data-id="element-136">
                {/* Content Side */}
                <div className="w-full md:w-1/2 pl-8 md:pl-0 md:pr-12 text-left md:text-right" data-id="element-137">
                  <div className={`${index % 2 === 0 ? 'md:text-left md:pl-12 md:pr-0' : ''}`} data-id="element-138">
                    <span className="text-gold-500 font-heading text-xl font-bold tracking-widest block mb-2" data-id="element-139">
                      {item.year}
                    </span>
                    <h3 className="text-2xl text-white font-bold uppercase mb-3" data-id="element-140">
                      {item.title}
                    </h3>
                    <p className="text-slate-400" data-id="element-141">{item.desc}</p>
                  </div>
                </div>

                {/* Center Dot */}
                <div className="absolute left-0 md:left-1/2 w-4 h-4 bg-navy-900 border-2 border-gold-500 rounded-full transform -translate-x-[7px] md:-translate-x-1/2 z-10" data-id="element-142">
                  <div className="absolute inset-0 m-1 bg-gold-500 rounded-full animate-pulse" data-id="element-143"></div>
                </div>

                {/* Empty Side for Spacing */}
                <div className="hidden md:block w-1/2" data-id="element-144"></div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </Section>;
}